import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { lighten, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import DeleteIcon from '@material-ui/icons/Delete';
import FilterListIcon from '@material-ui/icons/FilterList';
import { collectionlist, updateverification } from './../../actions/users';
import Search from "@material-ui/icons/Search";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import customInputStyle from "assets/jss/material-dashboard-react/components/customInputStyle.js";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/Input";
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import { Link, useHistory } from "react-router-dom";
import EditIcon from '@material-ui/icons/Edit';
import { toastAlert } from '../../lib/toastAlert'
import CardHeader from "components/Card/CardHeader.js";
import * as moment from "moment";
import StarIcon from '@material-ui/icons/Star';
import config from '../../lib/config';
import SearchBar from "material-ui-search-bar";
// function createData(FirstName, lastName, Email, phoneNo, accountType) {
//   return { FirstName, lastName, Email, phoneNo, accountType };
// }

const rows = [
    // getData('')
    //   createData('firstName', 'lastName', 'Email', 'phoneNo', 'accountType')
    //   createData('Donut', 452, 25.0, 51, 4.9),
];


const headCells = [
    { id: 'category', numeric: false, disablePadding: true, label: 'Collection Name' },
    { id: 'bidaddress', numeric: true, disablePadding: false, label: 'Collection Symbol' },
    { id: 'tokendate', numeric: true, disablePadding: false, label: 'Nft under this Collection' },
    { id: 'tokendate', numeric: true, disablePadding: false, label: 'Contract Address' },
    { id: 'tokendate', numeric: true, disablePadding: false, label: 'Network' },
    { id: 'tokendate', numeric: true, disablePadding: false, label: 'Verification Status' },
    { id: 'tokendate', numeric: true, disablePadding: false, label: 'Action' },
];

function EnhancedTableHead(props) {
    const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'center' : 'center'}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

const useToolbarStyles = makeStyles((theme) => ({
    root: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    title: {
        flex: '1 1 76%',
    },
}));

const EnhancedTableToolbar = (props) => {
    const classes = useToolbarStyles();
    const { numSelected } = props;

    return (
        <Toolbar
            className={clsx(classes.root, {
                [classes.highlight]: numSelected > 0,
            })}
        >
        </Toolbar>
    );
};

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onChangeterm: PropTypes.func.isRequired
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
}));


const customStyle = makeStyles(customInputStyle);

export default function EnhancedTable() {
    const classes = useStyles();
    const customStyles = customStyle();

    const classesSearch = useToolbarStyles();
    const [data, setData] = React.useState(0);
    const [orderBy, setOrderBy] = React.useState('calories');
    const [selected, setSelected] = React.useState([]);
    const [keyselected, setkeyselected] = React.useState("Select..");
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [userDetails, setUser] = useState([]);
    const [searchQuery, setSearchQuery] = React.useState("");
    const [typingTimeout, setTypingTimeout] = useState(0)
    const [order, setOrder] = React.useState('asc');
    const [searched, setSearched] = React.useState("");
    const [usercopy, setusercopy] = useState([]);





    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }


    function editR(id) {
        if (id != '') {
            window.location = "/sfgytndvfger/TokenView/" + id;
        }

    }
    function lock() {

    }
    const handleChange = (event) => {
        const { name, value } = event.target;
        const self = this;
        if (typingTimeout) {
            clearTimeout(typingTimeout);
        }

        setSearchQuery(value)
        setTypingTimeout(setTimeout(function () {
            getAll({ 'search': value });
        }, 1000))
    }

    const handleRequestSort = (event, property) => {

    }

    const requestSearch = (searchedVal: string) => {
        const filteredRows = usercopy.filter((row) => {
            return row.contractAddress.toLowerCase().includes(searchedVal.toLowerCase());
        });
        setUser(filteredRows);
    };

    const cancelSearch = () => {
        setSearched("");
        requestSearch(searched);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = rows.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };
    useEffect(() => {
        getAll();
    }, [])
    const getAll = async (search = {}) => {
        let filterData = search;
        if (filterData.search == '') {
            filterData = {}
        }
        var test = await collectionlist();
        console.log("tokenlistt", test)
        if (test && test.result && test.result.data && test.result.data.lists && test.result.data.lists.length > 0) {
            setusercopy(test.result.data.lists);
            setUser(test.result.data.lists);
            if (keyselected != "Select..") {
                keychange(keyselected, test.result.data.lists);
            }
        }
    }


    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    async function verifycollection(rec) {
        let inputdata = {
            contractAddress: rec && rec.contractdetails && rec.contractdetails.contractAddress ? rec.contractdetails.contractAddress : rec.contractAddress,
            ownerAddress: rec && rec.contractdetails && rec.contractdetails.ownerAddress ? rec.contractdetails.ownerAddress : rec.tokenOwner,
            network: rec.network,
            verificationstatus: "verified"
        }
        let result = await updateverification(inputdata);
        toastAlert('success', "Verified Successfully", 'Admin')
        await getAll();
    }

    async function rejectcollection(rec) {
        let inputdata = {
            contractAddress: rec.contractdetails.contractAddress,
            ownerAddress: rec.contractdetails.ownerAddress,
            network: rec.contractdetails.network,
            verificationstatus: "rejected"
        }
        let result = await updateverification(inputdata);
        toastAlert('success', "Rejected Successfully", 'Admin')
        await getAll();
    }

    async function keychange(val, user_copy) {
        console.log(val, "======val")
        setkeyselected(val);
        if (val != "All") {
            if (val == "Verified Collection") {
                const filteredRows = user_copy.filter((row) => {
                    return row.contractdetails && row.contractdetails.verificationstatus && row.contractdetails.verificationstatus == "verified";
                });
                setUser(filteredRows);
            }
            if (val == "UnVerified Collection") {
                let arr = [];
                // const filteredRows = user_copy.filter((row) => {
                //     return row.contractdetails && row.contractdetails.verificationstatus && row.contractdetails.verificationstatus == "pending";
                // });
                // const filteredRows1 = user_copy.filter((row) => {
                //     return row.contractdetails && row.contractdetails.verificationstatus && row.contractdetails.verificationstatus == "adminpending";
                // });
                const filteredRows2 = user_copy.filter((row) => {
                    return row.contractdetails && row.contractdetails.verificationstatus && row.contractdetails.verificationstatus == "rejected";
                });
                const staticfile = user_copy.filter((row) => {
                    return !row.contractdetails;
                });
                // console.log(filteredRows, "11", filteredRows1, "==22", filteredRows2, "====33", staticfile)
                // arr.push(...filteredRows);
                // arr.push(...filteredRows1);
                arr.push(...filteredRows2);
                arr.push(...staticfile);
                setUser(arr);
            }
            if (val == "Verification Request") {
                const filteredRows = user_copy.filter((row) => {
                    return row.contractdetails && row.contractdetails.verificationstatus && row.contractdetails.verificationstatus == "adminpending";
                });
                setUser(filteredRows);
            }
        } else {
            setUser(usercopy)
        }
    }

    const isSelected = (name) => selected.indexOf(name) !== -1;

    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                <Toolbar
                    className={clsx(classesSearch.root, {
                        [classesSearch.highlight]: selected.length > 0,
                    })}
                >
                    <Typography className={classesSearch.title} variant="h6" id="tableTitle" component="div">
                        Collection List
                    </Typography>
                    {/* <div className={classes.flexHeader}>
                            <Link to={'/addcategory'} className={classes.btnPrimary}>Add Category</Link>
                        </div> */}

                </Toolbar>
                <div className="table_filter">
                    <SearchBar
                        value={searched}
                        onChange={(searchVal) => requestSearch(searchVal)}
                        onCancelSearch={() => cancelSearch()}
                        placeholder='search contract address'

                        className=""
                    />
                    <div class="dropdown">
                        <button class="btn btn-light dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            {keyselected}
                        </button>
                        <div class="dropdown-menu" aria-labelledby="Select">
                            <a class="dropdown-item" href="#" onClick={() => keychange("All", usercopy)}>All</a>
                            <a class="dropdown-item" href="#" onClick={() => keychange("Verified Collection", usercopy)}>Verified Collection</a>
                            <a class="dropdown-item" href="#" onClick={() => keychange("UnVerified Collection", usercopy)}>UnVerified Collection</a>
                            <a class="dropdown-item" href="#" onClick={() => keychange("Verification Request", usercopy)}>Verification Request</a>
                        </div>
                    </div>
                </div>
                <TableContainer>
                    <Table
                        className={classes.table}
                        aria-labelledby="tableTitle"
                        // size={dense ? 'small' : 'medium'}
                        aria-label="enhanced table"
                    >
                        <EnhancedTableHead
                            classes={classes}
                            numSelected={selected.length}
                            //   order={order}
                            orderBy={orderBy}
                            onSelectAllClick={handleSelectAllClick}
                            onRequestSort={handleRequestSort}
                            rowCount={rows.length}
                        />
                        <TableBody>
                            {stableSort(userDetails, getComparator(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                                console.log(row, "rowrow");
                                return (
                                    <TableRow>
                                        <TableCell align="center">{row.collectionname}</TableCell>
                                        <TableCell align="center">
                                            {row.collectionsymbol}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row.count}
                                        </TableCell>
                                        <TableCell align="center">
                                            <a href={config.Front_URL + "/collections-details/" + row.contractAddress} target="_blank">{row.contractAddress}</a>
                                        </TableCell>
                                        <TableCell align="center">
                                            {row.network}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row && row.contractdetails && row.contractdetails.contractAddress ?
                                                row.contractdetails.verificationstatus == "pending" ?
                                                    "Not Verified" : row.contractdetails.verificationstatus == "rejected" ?
                                                        "Rejected By Admin" :
                                                        row.contractdetails.verificationstatus == "adminpending" ?
                                                            "Request Submitted"
                                                            : row.contractdetails.verificationstatus == "verified" ?
                                                                "Verified"
                                                                :
                                                                "Not verified"
                                                :
                                                "Not verified"
                                            }
                                        </TableCell>
                                        <TableCell align="center">
                                            {row && row.contractdetails && row.contractdetails.contractAddress ?
                                                row.contractdetails.verificationstatus == "pending" || row.contractdetails.verificationstatus == "rejected" || row.contractdetails.verificationstatus == "adminpending" ?
                                                    <Button type="button" className="ban_btn" onClick={() => verifycollection(row)}>Verify</Button>
                                                    : row.contractdetails.verificationstatus != "verified" &&
                                                    <Button type="button" className="ban_btn" onClick={() => verifycollection(row)}>Verify</Button>
                                                :
                                                <Button type="button" className="ban_btn" onClick={() => verifycollection(row)}>Verify</Button>
                                            }
                                            {row && row.contractdetails && row.contractdetails.contractAddress && (row.contractdetails.verificationstatus == "adminpending" || row.contractdetails.verificationstatus == "verified") &&
                                                <Button type="button" className="ban_btn" onClick={() => rejectcollection(row)}>Remove</Button>
                                            }
                                        </TableCell>
                                    </TableRow>
                                );
                            })
                            }

                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={userDetails && userDetails.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </Paper>
        </div>
    );
}